import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CUSTOMER_TOKEN } from "../constants/constants";
import { AuthStage } from "../redux/features/customer/customer.types";
import { useAppSelector } from "../redux/store";
import { consumePostAuthRedirect } from "../utils/auth_redirect";

export function useAuthStage() {
  const { authStage, customer, otpPhone } = useAppSelector(
    (state) => state.customer
  );
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!otpPhone) {
      if (location.pathname !== "/login") {
        navigate("/login", { replace: true });
      }
      return;
    }

    switch (authStage) {
      case AuthStage.OTP_SENT:
        navigate("/verify");
        break;
      case AuthStage.OTP_VERIFIED_NO_USER:
        if (otpPhone && !customer) {
          navigate("/complete_profile");
        }
        break;
      case AuthStage.OTP_VERIFIED_WITH_USER:
        if (customer) {
          localStorage.setItem(CUSTOMER_TOKEN, customer.token);
          navigate("/complete_profile");
        }
        break;
      case AuthStage.PROFILE_COMPLETE:
        if (customer) {
          navigate(consumePostAuthRedirect() ?? "/home", { replace: true });
        }
        break;
      case AuthStage.DEFAULT:
        navigate("/login");
        break;
    }
  }, [authStage, customer, location.pathname, otpPhone, navigate]);
}
